/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  $('a[href*="#"]').each((i, link) => {
    const $link = $(link)
    const anchor = $link.attr('href').substring(1)

    if ($('a[name="' + anchor + '"]').length) {
      $link.on('click', event => {
        const $linkTarget = $('a[name="' + anchor + '"]')
        let position = 0

        if ($linkTarget.next()[0].tagName == 'SECTION') {
          position = $linkTarget.next().position().top
        } else {
          position = $('a[name="' + anchor + '"]')
            .parents('section')
            .first()
            .position().top
        }

        const scroll = $(window).scrollTop()
        const time = Math.min(Math.abs(scroll - position) / 3, 1500) // distance / 3, or 1.5 seconds max

        $('html, body').animate({ scrollTop: position }, time, 'swing')
      })
    }
  })
}
